import { memo, useEffect } from 'react';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { GAUGE } from '../../constants/visualizationTypes';
// @ts-expect-error untyped dependency
import Highchart from '../../highcharts/Highchart';
import { getChartOptions } from './GaugeMapper';
import { GaugeVisualizationRecord } from './GaugeRecords';
import { jsx as _jsx } from "react/jsx-runtime";
const GaugeVisualization = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize,
  reportingThemes
}) => {
  const chartOptions = getChartOptions(visualization, debug, reportingThemes);
  useEffect(() => {
    debug.set('Highcharts', chartOptions);
  }, [chartOptions, debug]);
  return /*#__PURE__*/_jsx(Highchart, {
    chartOptions: chartOptions,
    setExtremesForZeroState: false,
    onReportVisualize: onReportVisualize
  });
};
export const type = GAUGE;
export const record = GaugeVisualizationRecord;
export const Render = /*#__PURE__*/memo(GaugeVisualization);
export const VisualizationContainerStyle = {
  blockSize: '100%'
};